// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog-title__text[data-v-d13d17e0]{font-weight:700;font-size:28px;line-height:40px;letter-spacing:.5px}.close-dialog__icon[data-v-d13d17e0]{cursor:pointer;align-self:start}[data-v-d13d17e0] .v-toolbar__content{padding-right:0}.close-btn[data-v-d13d17e0],.save-btn[data-v-d13d17e0]{border-radius:35px;font-size:13px}.close-btn[data-v-d13d17e0]{text-decoration:underline;font-weight:700;letter-spacing:.5px}", ""]);
// Exports
module.exports = exports;
